import moment from 'moment';

/**
 * 日時の文字列を変換する
 * @param {string} dateString 日付文字列
 * @param {string} format フォーマット
 */
export const dateFormat = (dateString, format = 'YYYY/MM/DD') =>
  moment(dateString).format(format);

/**
 * 数値をカンマ区切りにする
 * @param {number} number
 */
export const toLocalString = number =>
  number ? (+number).toLocaleString() : '';

/**
 * \nのエスケープを外す
 * @param {string} string
 */
export const nl2 = string => (string ? string.replace(/\\n/g, '\n') : '');

/**
 * 入力文字列を改行の位置で省略する
 * @param {String} input
 */
export const ellipsisNL = input => {
  const match = input.match(/\n/);
  const index = match ? match.index : -1;

  return index >= 0 ? input.slice(0, index) + '...' : input;
};

/**
 * 数値を指定した桁でゼロパディングする
 * @param {string} numString
 * @param {number} length
 */
export const zeroPadStart = (numString, length = 6) =>
  numString ? ('' + numString).padStart(length, '0') : '';

/**
 * ゼロパディングの数値文字列をゼロパディング無しに変換する
 * @param {string} numString
 */
export const formatZeroPadNumString = numString =>
  isNaN(+numString) ? '' : '' + +numString;



// WEBPACK FOOTER //
// ./src/util/filters.js